import React from 'react';
import { getRequiredLabel } from '../components/custom_widgets/widgetUtil'

/**
 * Custom field template for react-jsonschema-form.
 * This is required for custom behaviour for API Input forms with Katal Web Components.
 * https://react-jsonschema-form.readthedocs.io/en/latest/advanced-customization/
 * https://katal.corp.amazon.com/
 */
export const CustomFieldTemplate = (props: any) => {
    let fieldTemplate = customFieldOfSchemaTypes(props);
    if (fieldTemplate) {
        return fieldTemplate;
    }
    return customFieldOfDataFormat(props);
};


const customFieldOfSchemaTypes = (props: any) => {
    const {label, help, required, description, errors, children, schema} = props;
    const schemaType = schema.type;

    switch (schemaType) {
        /**
         * For Form Header.
         * Remove the descriptions as it is handled in custom ways by providing description as a tooltip
         */
        case 'object': {
            return (
                <React.Fragment>
                    {children}
                    {errors}
                    {help}
                </React.Fragment>
            );
        }

        case 'array': {
            return (
                <React.Fragment>
                    <h5>{getRequiredLabel(required, label)}</h5>
                    {description}
                    {children}
                    {errors}
                    {help}
                </React.Fragment>
            );
        }

        default:
            return undefined;
    }
};

export const customFieldOfDataFormat = (props: any) => {
    const {label, help, description, errors, children, schema, uiSchema} = props;
    let dataFormat = schema.format;
    const type = schema.type;

    switch (type) {
        case 'string': {
            switch (dataFormat) {
                case 'data-url':
                case 'textarea':
                case 'date': {
                    return (
                        <React.Fragment>
                            {description}
                            {children}
                            {errors}
                            {help}
                        </React.Fragment>
                    );
                }
                default: {
                    return (
                        <React.Fragment>
                            {description}
                            {children}
                            {help}
                        </React.Fragment>
                    );
                }
            }
        }

        case 'number': {
            return (
                <React.Fragment>
                    {description}
                    {children}
                    {help}
                </React.Fragment>
            );
        }

        default: {
            switch (dataFormat) {
                case 'data-url':
                case 'textarea':
                case  'uri': {
                    return (
                        <React.Fragment>
                            <p>{label}</p>
                            {description}
                            {children}
                            {errors}
                            {help}
                        </React.Fragment>
                    );
                }

                default: {
                    return (
                        <React.Fragment>
                            {description}
                            {children}
                            {errors}
                            {help}
                        </React.Fragment>
                    );
                }
            }
        }
    }

};
